import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import React, { useState } from 'react';

const ConfirmDialog = ({ open, onYes, onNo, title, message, yesCaption, noCaption }) => {
  const handleClose = () => {};

  if (!open) return '';

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onYes} color="primary">
          {yesCaption || 'Yes'}
        </Button>
        <Button onClick={onNo} color="primary" autoFocus>
          {noCaption || 'No'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
